import { ChangeEvent, VFC } from 'react';

import { TemplateLiteral } from 'dashboard/lib/case-layouts/computed-properties';
import Input from 'design-system/components/Input';

export interface CasesCustomCodeInput {
  templateLiteral: TemplateLiteral;
  onSerializedCodeUpdate: (serializedCode: string) => void;
}

export const TemplateLiteralInput: VFC<CasesCustomCodeInput> = ({
  templateLiteral,
  onSerializedCodeUpdate,
}) => {
  const deserializedCode = templateLiteral['serialized-code']
    ? atob(templateLiteral['serialized-code'])
    : '';

  const handleOnCodeUpdate = (code: string) => {
    onSerializedCodeUpdate(btoa(code));
  };

  return (
    <Input
      type='text'
      value={deserializedCode}
      onChange={(e: ChangeEvent<HTMLInputElement>) => {
        handleOnCodeUpdate(e.target.value);
      }}
    />
  );
};
